import _extends from "@babel/runtime/helpers/esm/extends";
/**
 * MuiChip
 *
 * Styles:
 *
 * - [Proto](https://www.figma.com/design/9v0wqs4KtnOVtTD7QdCI1H/Digital-Forms-1.2?node-id=6590-345443&t=KtDLDlNGLaLBVpsS-0)
 */
const MuiChip = {
  styleOverrides: {
    root: ({
      theme
    }) => _extends({}, theme.typography.body2, {
      minWidth: 74
    }),
    // @ts-expect-error MUI theme is not exposing this type but it's correct
    outlinedDefault: ({
      theme
    }) => ({
      color: theme.palette.secondary.main,
      borderColor: theme.palette.grey[300],
      '&.MuiChip-clickable:hover': {
        color: theme.palette.secondary[900],
        backgroundColor: theme.palette.secondary[50]
      },
      '&:focus': {
        borderColor: theme.palette.secondary.light,
        boxShadow: `inset 0 0 0 1px ${theme.palette.secondary.light}`
      },
      '&.Mui-disabled': {
        color: theme.palette.grey[500],
        backgroundColor: theme.palette.grey[100],
        borderColor: theme.palette.grey[300],
        opacity: 1
      },
      '&.Mui-selected': {
        color: theme.palette.secondary[900],
        backgroundColor: theme.palette.grey[100],
        '& > .MuiChip-label': {
          display: 'flex',
          '& > .MuiSvgIcon-root': {
            marginLeft: theme.spacing(-1),
            marginRight: theme.spacing(0.5)
          }
        }
      }
    })
  }
};
export const LumaChip = {
  defaultProps: {
    includeSelectedIcon: true
  }
};
export default MuiChip;